import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy } from '@angular/core';
import { FloatingInfoService } from '@core/services/floating-info-service/floating-info-service.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-floating-info',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-info.component.html',
  styleUrl: './floating-info.component.scss',
})
export class FloatingInfoComponent implements OnDestroy {
  textParts: string[] = [];
  position = { x: 0, y: 0 };

  showing = false;

  subscriptions = new Subscription();

  constructor(private floatingInfoService: FloatingInfoService) {}

  ngOnInit() {
    const sub = this.floatingInfoService.currentInformation.subscribe(
      (data) => {
        this.textParts = data;
      },
    );

    const sub2 = this.floatingInfoService.infoShowing.subscribe((data) => {
      this.showing = data;
    });

    const sub3 = this.floatingInfoService.newPosition.subscribe((data) => {
      this.position = data;
    });

    this.subscriptions.add(sub);
    this.subscriptions.add(sub2);
    this.subscriptions.add(sub3);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    this.position.x = event.pageX;
    this.position.y = event.pageY;
  }

  @HostListener('document:touchmove', ['$event'])
  onTouchMove(event: TouchEvent): void {
    console.log('AAA', event.touches[0]);
    this.position.x = event.touches[0].pageX;
    this.position.y = event.touches[0].pageY;
  }

  /*@HostListener('document:drag', ['$event'])
  onDrag(event: DragEvent): void {
    this.position.x = event.pageX;
    this.position.y = event.pageY;
  }*/
}
